<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Visualizar Perfil</div>
            </div>
            <div class="card-body">
              <div class="user-img">
                <img v-if="previewImage" :src="previewImage" class="photo" />
                <img v-else :src="users.photo" class="photo" />
              </div>
              <div class="profile_user form-group">
                <h3 class="user_name_max" style="text-align: center">
                  {{ users.name }}
                </h3>
                <hr />
                <p style="text-align: center">{{ users.email }}</p>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="userName">
                          <span class="required">*</span> Nome:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.name"
                          placeholder
                          disabled
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputEmail4">
                          <span class="required">*</span> Email:
                        </label>
                        <input
                          disabled
                          autocomplete="off"
                          class="form-control"
                          id="userEmail"
                          placeholder=""
                          type="text"
                          v-model="users.email"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="Cellphone">
                          <span class="required">*</span> Celular:
                        </label>
                        <input
                          class="form-control"
                          type="text"
                          v-mask="'(##) 99999-9999'"
                          v-model="users.cellphone"
                          disabled
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="Phone">Telefone:</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.telphone"
                          v-mask="'(##) 9999-9999'"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="inputCompany">
                          <span class="required">*</span> Empresa:
                        </label>
                        <select
                          v-model="users.company_id"
                          class="form-control"
                          disabled
                        >
                          <option
                            v-for="company in companies"
                            :value="company.id"
                            :key="company.id"
                          >
                            {{ company.company_name_fantasy }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputDepartment">
                          <span class="required">*</span> Departamento:
                        </label>
                        <select
                          v-model="users.department_id"
                          class="form-control"
                          disabled
                        >
                          <option
                            v-for="department in departments"
                            :value="department.id"
                            :key="department.id"
                          >
                            {{ department.description }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputUser">
                          <span class="required">*</span> Nivel Acesso:
                        </label>
                        <select
                          v-model="users.access_nivel"
                          class="form-control"
                          disabled
                        >
                          <option :value="1" :key="1">Usuário Padrão</option>
                          <option :value="2" :key="2">Empresa</option>
                          <option :value="3" :key="3">Administrador</option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label>
                          Grupos do usuário:
                        </label>
                        <v-select 
                        disabled
                        multiple
                        label="title"
                        v-model="users.users_groups"
                        :options=users_groups></v-select> 
                      </div>                   
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="userPosition">
                            <span class="required">*</span> Aceitou Termos de
                            Utilização?
                          </label>
                          <select
                            v-model="users.accept_terms"
                            class="form-control"
                            disabled
                          >
                            <option value="0">Não</option>
                            <option value="1">Sim</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6" v-if="users.accept_terms == 1">
                        <div class="form-group">
                          <label for="userPosition">
                            <span class="required">*</span> Data de Aceite
                          </label>
                          <input
                            disabled
                            autocomplete="off"
                            class="form-control"
                            placeholder=""
                            type="userDateAccept"
                            v-model="users.e_date_accept"
                          />
                        </div>
                      </div>
                      <div class="col-md-6" v-if="users.accept_terms == 1">
                        <div class="form-group">
                          <label for="userPosition">
                            <span class="required">*</span> Versão do Termo
                          </label>
                          <input
                            disabled
                            autocomplete="off"
                            class="form-control"
                            placeholder=""
                            type="text"
                            v-model="users.version_term"
                          />
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="block text-right">
                      <router-link to="/users" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      companies: [],
      departments: [],
      users_groups: [],
      users: {
        name: "",
        email: "",
        cellphone: "",
        telphone: "",
        photo: "",
        access_nivel: "3",
        company_id: "",
        department_id: "",
        date_accept: "",
        users_groups: [],
      },
      branches: {
        cities: [
          {
            title: "",
          },
        ],
        states: [
          {
            title: "",
          },
        ],
      },
      errors: undefined,
    };
  },
  computed: {},
  methods: {
    getUsers: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api +
        "users/" +
        id +
        "?with[]=branches&with[]=departments&with[]=users_groups";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data[0];
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    getDepartments: function (id) {
      const self = this;
      const api = self.$store.state.api + "departments/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsersGroups: function (id) {
      const self = this;
      const api = self.$store.state.api + "users_groups/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users_groups = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    let self = this;
    let id = self.$route.params.id;

    self.getDepartments();
    self.getCompanies();
    self.getUsersGroups();

    if (id) {
      self.getUsers(id);
    }
  },
  components: {
    vSelect,
  },
};
</script>
<style scoped>
.uploading-image {
  display: flex;
  border-radius: 20px;
  width: 250px;
  height: 198px;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 10px;
  height: 200px;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/User/View.vue